export default {
  creatOrderData: '/gateway/capp/mallcenter/order/createOrder',
  getCreatOrderData: '/gateway/capp/mallcenter/order/preCreateOrder',
  getPayAgentList: '/payment/getPayAgentList',
  getOrderInfo: '/gateway/capp/mallcenter/order/queryResultAfterOrderPay',
  payOrder: '/gateway/capp/mallcenter/order/payOrder',
  couponList: '/gateway/coupon/shopCoupon/getCouponList'
}
